<template>
  <div class="details-project">
    <div class="jp-line"></div>
    <!-- <h2>{{projectItem.title }}</h2> -->
    <div class="jp-column">
      <span class="title">{{projectItem.title}}</span>
      <div class="my-5">
        <p>{{projectItem.content}}</p>
      </div>
    </div>
    <div class="project-show">
      <div class="jp-column">
        <el-row :gutter="30">
          <el-col :span="6" :xs="24" v-for="(item, index) in projectItem.item" :key="index"  class="jp-news-list-card">
            <el-card :body-style="{ padding: '0px' }">
              <div class="jp-overflow-hidden">
                <img :src="item.img" class="image" />
              </div>
              <div style="padding: 15px;">
                <h3>{{item.name}}</h3>
                <!-- <div class="bottom clearfix">
                  <time class="time">2020-01-01</time>
                  <div class="text-right my-3 detail">{{$t('common.viewDetails')}} <i class="el-icon-right"></i></div>
                </div> -->
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsProject',
  props: {
    projectItem: {
      type: Object,
      default: {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/style/variables.scss';

.details-project {
  text-align: left;
  h2 {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.125rem;
    text-align: center;
  }
  p {
    font-size: 1.125rem;
  }
  .project-show {
    background-color: #e6ebf7;
    padding: 1.6rem 0;
  }
}
@media (max-width: 768px) {
  .details-project {
    .jp-news-list-card {
      margin-top: 2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detailsProject.vue